import app from 'flarum/forum/app';
import Modal, {IInternalModalAttrs} from 'flarum/common/components/Modal';
import Discussion from 'flarum/common/models/Discussion';
import AuditBrowser from '../../common/components/AuditBrowser';

interface UserAuditModalAttrs extends IInternalModalAttrs {
    discussion: Discussion
}

export default class DiscussionAuditModal extends Modal<UserAuditModalAttrs> {
    className() {
        return 'AuditModal DiscussionAuditModal';
    }

    title() {
        return app.translator.trans('kilowhat-audit.forum.modal.discussion-title');
    }

    content() {
        return AuditBrowser.component({
            baseQ: 'discussion:' + this.attrs.discussion.id(),
        });
    }
}
